import { Injectable, Optional } from '../components/dependency-injection/decorators';
import { AdSlotLifecycleEvent } from '../components/event-manager/event/ad-slot-lifecycle.event';
import { Events } from '../components/event-manager/event/events';
import { Logger } from '../components/logger/logger';
import { EventSubscriberInterface } from '../interfaces/components/event-manager/subscriber/event-subscriber.interface';

@Injectable()
export class AdSlotSubscriber implements EventSubscriberInterface {
  public constructor (
    @Optional() private readonly logger?: Logger,
  ) {
  }

  public getSubscribedEvents (): { [key in Events]?: string } {
    return {
      [ Events.AD_SLOT_PRE_RENDER ]: 'onPreRender',
      [ Events.AD_SLOT_POST_RENDER ]: 'onPostRender',
    };
  }

  public async onPreRender (event: AdSlotLifecycleEvent): Promise<void> {
    this.logger?.debug(`Ad slot ${event.getAdSlot().getId()} onPreRender`);
  }

  public onPostRender (event: AdSlotLifecycleEvent): void {
    this.logger?.debug(`Ad slot ${event.getAdSlot().getId()} onPostRender`);
  }
}
